import React from "react";
import Header from "../components/Header"

const contacts = ()=>{
    return(
        <div>
            <Header page="Contact Me"/>
            <ul>
                <li><a href="https://www.linkedin.com/in/matthew-weston-646630199/">LinkedIn</a></li>
                <li>mweston6288@gmail.com</li>
                <li>mweston6288@knights.ucf.edu</li>
            </ul>
        </div>
    )
}
export default contacts;